export * from "./pTableSimple.type";
export * from "./PTableSimple.vue";
export * from "./PTableSimpleRowColorize";
